import React from "react";

import { Text } from "../../primitive";
import { Box } from "../../primitive/Box/Box";

/**
 * Badge component for displaying notification numbers on buttons
 */
export const Badge: React.FC<{ number: number }> = ({ number }) => {
  return (
    <Box
      position="absolute"
      right={-6}
      bottom={-4}
      width={24}
      height={24}
      zIndex={100}
      bg="outline-inverse"
      borderRadius="1"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        width={20}
        height={20}
        bg="main-primary-500"
        justifyContent="center"
        alignItems="center"
        borderRadius="1"
      >
        <Text variant="mainSmallSemiBold" color="text-inverse">
          {number}
        </Text>
      </Box>
    </Box>
  );
};
